module.exports = __webpack_public_path__ + "static/img/new.7fc2ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/new.png
// module id = 4ZSR
// module chunks = 2 3